// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { AxiosInstance, AxiosResponse, AxiosRequestConfig, AxiosRequestHeaders } from 'axios';
import axios from 'axios';
import FormData from 'form-data';
import { Moment } from 'moment';
import { Inject, Scoped } from 'vue-di';

/* tslint:disable:no-unused-locals */
import {
    Serializer,
    UNKNOWN_BASE_TYPE,
    SurveyFullSurveySessionValuesModel,
    SurveyIdListRequestModel,
    SurveyResponseModel,
    SurveySaveQuestionResultModelResponse,
    SurveySaveQuestionResultRequestModel,
    SurveySessionValueReadModels,
    SurveyStartSessionModelResponse,
    SurveyStartSessionRequestModel,
} from '@trialcard/apigateway.models';
import { Authentication, ApiKeyAuth, OAuth, OAuthTokenProvider, NullAuthTokenProvider, OAUTH_TOKEN_PROVIDER } from '@trialcard/authentication';
import * as enums from '@trialcard/enums';
import {
    createAxiosHeaders,
    EntLibServiceClient,
    RequestFile,
    X_TC_USERID,
    ConfigureWith,
    SetPackageName,
} from '@trialcard/shared';
import { AXIOS, AUDIENCE, BASE_PATH } from './symbols.js';
import { configure } from './configure.js';

// ===============================================
// This file is autogenerated - Please do not edit
// ===============================================

@Scoped
@ConfigureWith(configure)
@SetPackageName('@trialcard/apigateway.client')
export class SurveyV3Api extends EntLibServiceClient {
    protected authentications: {
        'Token': Authentication;
        'UserId': ApiKeyAuth;
    }

    public constructor(
        @Inject(AXIOS) private readonly axios: AxiosInstance,
        @Inject(X_TC_USERID) xTcUserId: string,
        @Inject(AUDIENCE) audience: string,
        @Inject(BASE_PATH) url: string,
        @Inject(OAUTH_TOKEN_PROVIDER) tokenProvider: OAuthTokenProvider) {
        super();
        this.authentications = {
            'Token': new OAuth({ name: 'apigateway', url, audience }, tokenProvider),
            'UserId': new ApiKeyAuth('header', 'x-tc-userid'),
        };

        if ((this.authentications as any).UserId) {
            (this.authentications as any).UserId.apiKey = xTcUserId;
        }
    }

    /**
     * 
     * @summary Get a list of Question and chosen Answers related to a list of Survey Session IDs.
     * @param surveyIdListRequestModel Survey Session IDs
     */
    public async fullSurveySessionByIdsCreate0 (surveyIdListRequestModel: SurveyIdListRequestModel): Promise<AxiosResponse<SurveySessionValueReadModels>> {
        const _url_ = '/survey/v3/FullSurveySessionByIds';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'surveyIdListRequestModel' is not null or undefined
        if (surveyIdListRequestModel === null || surveyIdListRequestModel === undefined) {
            throw new Error('Required parameter surveyIdListRequestModel was null or undefined when calling fullSurveySessionByIdsCreate0.');
        }


        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(surveyIdListRequestModel, "SurveyIdListRequestModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<SurveySessionValueReadModels>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "SurveySessionValueReadModels");
        }
        return response;
    }
    /**
     * 
     * @summary Creates a new full survey session including questions and answers
     * @param surveyFullSurveySessionValuesModel The session values to create
     */
    public async fullSurveySessionCreate0 (surveyFullSurveySessionValuesModel: SurveyFullSurveySessionValuesModel): Promise<AxiosResponse<SurveyResponseModel>> {
        const _url_ = '/survey/v3/FullSurveySession';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'surveyFullSurveySessionValuesModel' is not null or undefined
        if (surveyFullSurveySessionValuesModel === null || surveyFullSurveySessionValuesModel === undefined) {
            throw new Error('Required parameter surveyFullSurveySessionValuesModel was null or undefined when calling fullSurveySessionCreate0.');
        }


        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(surveyFullSurveySessionValuesModel, "SurveyFullSurveySessionValuesModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<SurveyResponseModel>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "SurveyResponseModel");
        }
        return response;
    }
    /**
     * 
     * @summary Gets a full survey session including questions and answers
     * @param id Survey Session ID
     */
    public async fullSurveySessionGet1 (id: number): Promise<AxiosResponse<SurveySessionValueReadModels>> {
        const _url_ = '/survey/v3/FullSurveySession/{id}'
            .replace('{' + 'id' + '}', encodeURIComponent(String(id)));
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'id' is not null or undefined
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling fullSurveySessionGet1.');
        }


        const requestConfig: AxiosRequestConfig = {
            method: 'GET',
            params: _params_,
            headers: _headers_,
            url: _url_,
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<SurveySessionValueReadModels>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "SurveySessionValueReadModels");
        }
        return response;
    }
    /**
     * 
     * @summary Create a session response record.
     * @param surveySaveQuestionResultRequestModel 
     */
    public async sessionValueCreate0 (surveySaveQuestionResultRequestModel: SurveySaveQuestionResultRequestModel): Promise<AxiosResponse<SurveySaveQuestionResultModelResponse>> {
        const _url_ = '/survey/v3/SessionValue';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'surveySaveQuestionResultRequestModel' is not null or undefined
        if (surveySaveQuestionResultRequestModel === null || surveySaveQuestionResultRequestModel === undefined) {
            throw new Error('Required parameter surveySaveQuestionResultRequestModel was null or undefined when calling sessionValueCreate0.');
        }


        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(surveySaveQuestionResultRequestModel, "SurveySaveQuestionResultRequestModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<SurveySaveQuestionResultModelResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "SurveySaveQuestionResultModelResponse");
        }
        return response;
    }
    /**
     * 
     * @summary Create a new Survey Session definition.
     * @param surveyStartSessionRequestModel StartSessionRequestModel object
     */
    public async surveySessionCreate0 (surveyStartSessionRequestModel: SurveyStartSessionRequestModel): Promise<AxiosResponse<SurveyStartSessionModelResponse>> {
        const _url_ = '/survey/v3/SurveySession';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'surveyStartSessionRequestModel' is not null or undefined
        if (surveyStartSessionRequestModel === null || surveyStartSessionRequestModel === undefined) {
            throw new Error('Required parameter surveyStartSessionRequestModel was null or undefined when calling surveySessionCreate0.');
        }


        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(surveyStartSessionRequestModel, "SurveyStartSessionRequestModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<SurveyStartSessionModelResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "SurveyStartSessionModelResponse");
        }
        return response;
    }
}
